import { WorkspaceConfiguration } from '../workspaceConfiguration';
declare var IS_ON_PREM: boolean;

export function hasFeatureCanary(
	workspaceConfiguration: WorkspaceConfiguration,
	canary: string,
	featureCanariesAvailable: string[] = featureCanariesOnPrem
) {
	return (
		isFeatureAvailableInCanaryList(workspaceConfiguration, canary) ||
		isFeatureEnabledForOnPrem(workspaceConfiguration, canary, featureCanariesAvailable)
	);
}

const isFeatureAvailableInCanaryList = (
	workspaceConfiguration: WorkspaceConfiguration,
	canaryName: string
) => {
	return !!workspaceConfiguration?.featureCanaries?.canary.some(
		({ name }) => name?.toLowerCase() === canaryName?.toLowerCase()
	);
};

function isFeatureEnabledForOnPrem(
	workspaceConfiguration: WorkspaceConfiguration,
	featureFlagName: string,
	featureCanariesAvailable: string[]
) {
	if (!IS_ON_PREM) {
		return false;
	}

	const isFeatureEnabledForStorefront = (featureName: String) => {
		return !!workspaceConfiguration?.featureToggles?.feature?.some(
			({ name, enabled }) =>
				name?.toLowerCase() === featureName?.toLowerCase() &&
				enabled?.toLowerCase() === 'true'
		);
	};

	// Check if the feature is enabled in Storefront with the given name
	if (isFeatureEnabledForStorefront(featureFlagName)) {
		return true;
	}

	// else check for the status with translated name...
	const onPremFeatureName = cloudToOnpremFeatureNameMap.get(featureFlagName);
	return onPremFeatureName
		? isFeatureEnabledForStorefront(onPremFeatureName)
		: featureCanariesAvailable.some(
				name => name?.toLowerCase() === featureFlagName?.toLowerCase()
		  );
}

//The Map contains the cloud feature flag name as key, and corresponding storefront feature flag name as value.
const cloudToOnpremFeatureNameMap = new Map([
	['WSHELP301EnableUserDisplayName', 'Citrix.StoreFront.WorkspaceUI.EnableUsername'],
	[
		'WSUI4148IsAppProtectionEnabled',
		'Citrix.StoreFront.AppProtectionPolicy.HybridLaunch',
	],
]);

const featureCanariesOnPrem: string[] = [
	'WSUI7054FilesIntegrationDisabled',
	'WSUI6282FuzzySearch',
	'WSHELP301EnableUserDisplayName',
	'WSUI8335DetectClientBeforeAuthentication',
	'WSUI9765EnableOpenCitrixForLinux',
	'WSUI9765EnableOpenCitrixForChromeOS',
	'WSUI8552EnableSynchronousAppShell',
	'WSHELP417UseFixForDesktopAvailability',
	'WSUI9333AllowOnlyJsonIca',
	'WSUI9628ForceEnableNewUI',
	'WSUI9293CustomLinkBanner',
	'WSUI9437ActivityManagerRefactoring',
	'WSUI10311AllowWorkspaceControl',
	'WSUI7246EnableMachinePowerState',
	'WSUI10305AllowBlueTheme',
	'WSUI9953SupportClientDetectionIOS',
	'WSUI9953SupportClientDetectionAndroid',
	'WSUI9953SupportClientDetectionChromeOS',
	'WSUI9612UseServerConfirForProtocolHandler',
	'WSUI6395NoEmptyAppsOrEmptyDesktopSection',
	'WSUI7083EnableHybridAADSSO',
	'WSUI7929EnableGACitrixAADSSO',
	'WSUI10968EnableHybridAADSSOMac',
	'WSUI10968EnableHybridAADSSOLinux',
	'WSUI9541GlobalAppConfigv2',
	'WSUI11063GACSHybridViaBXTN',
	'WSUI110812GACSHybridForChromeApp',
	'WSUI11075EnableDisconnectAndLogout',
	'WSUI11264EnableReadyPowerState',
	'WSUI9266EnableIcaDownloadUsingFetch',
	'WSUI11607RemoveCSRFTokenFromSaaSLaunchInNewTab',
	'WSUI11360InteractiveSearchModuleFavoriteIcon',
	'WSUI10031EnableInspectConnection',
	'WSUI11047EnableSessionReconnect',
	'WSUI10804DetailedDesktopView',
	'WsuiEnableChromeAppShield',
];
